// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  workspaceId: __t.u64(),
  sourceKind: __t.string(),
  sourceId: __t.u64(),
  teamRecipeJson: __t.string(),
  personaContractVersionsJson: __t.string(),
  modelVersionsJson: __t.string(),
  harness: __t.string(),
  budgetMicros: __t.i64(),
};
